import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import IMGAiFrameComponent from './js/imga-iframe.component';

ComponentsFactory.getInstance().define('imga-iframe', IMGAiFrameComponent);
